import { Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { useEffect, useState, useRef } from 'react';
import apiService from '../services/api';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requirePro?: boolean;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, requirePro = false }) => {
  const { user, loading, checkAuth } = useAuth();
  const [verifying, setVerifying] = useState(false);
  const [initialized, setInitialized] = useState(false);
  const validatedOnce = useRef(false);

  useEffect(() => {
    if (requirePro && !validatedOnce.current) {
      validatedOnce.current = true;
      setVerifying(true);
      checkAuth().finally(() => {
        setVerifying(false);
        setInitialized(true);
      });
      return;
    }
    setInitialized(true);
  }, [requirePro]);

  if (loading || verifying || !initialized) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  const hasToken = apiService.isAuthenticated();
  if (!user && !hasToken) {
    return <Navigate to="/login" replace />;
  }

  if (requirePro && (Number(user?.is_pro) !== 1)) {
    return <Navigate to="/checkout" replace />;
  }

  return <>{children}</>;
};
